import { Chapter, FadeUp } from "@/components/Reveal";

export default function TripleCulture() {
  return (
    <section id="triple-culture" className="bg-slate-50" data-testid="triple-culture-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
        <FadeUp>
          <Chapter index="02" label="Manifeste" />
        </FadeUp>
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
          <FadeUp className="lg:col-span-6">
            <h2 className="w-full break-words whitespace-normal font-sans font-extrabold uppercase text-slate-900 text-2xl sm:text-3xl lg:text-4xl leading-[1.15] tracking-tight">
              Une triple culture : chiffre, réalité terrain, technologie.
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="lg:col-span-6">
            <blockquote
              data-testid="foundress-quote"
              className="w-full break-words whitespace-normal font-sans italic font-medium text-slate-800 text-xl sm:text-2xl leading-relaxed"
            >
              « Mon parcours s'est forgé au cœur du réacteur : piloter le quotidien sous tension
              et stabiliser l'entreprise lors de crises majeures. Dans ces dossiers à forts
              enjeux, je sais d'expérience que le temps et la précision sont vitaux. »
            </blockquote>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
              Lucile Reimonenq, Fondatrice — MBA ESSEC &amp; ICCF @ HEC Paris (En cours)
            </p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
